<script setup>

import Attention from "@/Components/Icons/Attention.vue";
import dayjs from "dayjs";
import {computed, ref} from "vue";
import {route} from "ziggy-js";

const props = defineProps({
    message: Object,
    participants: Array,
})

const buyer = ref(null),
    seller = ref(null)

props.participants.forEach(participant => {
    if (participant.user.id === props.message.order.offer.user.id) {
        seller.value = participant.user
    } else {
        buyer.value = participant.user
    }
})


const msgHtml = computed(() => {

    return '<p class="font-normal dark:text-slate-200 tracking-wider leading-120 font-normal">' + props.message.template
            .replaceAll('{seller}', `<a href="${route('users.show.offers', {user: seller.value})}" class="text-blue-600 dark:text-cyan-300 font-medium" target="_blank">${seller.value.name}</a>`)
            .replaceAll('{order}', `<a href="${route('orders.show', props.message.order)}" class="text-blue-600 dark:text-cyan-300 font-medium" target="_blank">${props.message.order?.code}</a>`)
            .replaceAll('{offer}', `${props.message.order?.offer.title}`)
            .replaceAll('{buyer}', `<a href="${route('users.show.reviews', {user: buyer.value})}" class="text-blue-600 dark:text-cyan-300 font-medium" target="_blank">${buyer.value?.name}</a>`)
        + '</p>';
})

</script>

<template>
    <div class="bg-green-100 dark:bg-emerald-600 rounded-lg px-2 py-1">
        <div class="flex justify-between leading-120 mb-1">
            <span class="text-blue-600 text-sm dark:text-cyan-300">ANYKOD</span>
            <span
                class="text-xs text-slate-500 font-normal dark:text-slate-400">{{
                    dayjs(message.created_at).format('HH:mm')
                }}</span>
        </div>
        <div class="flex gap-1">
            <div class="w-3.5 h-3.5">
                <attention class="fill-blue-600 dark:fill-cyan-300"/>
            </div>

            <div class="text-sm leading-120  tracking-wider" v-html="msgHtml">
            </div>
        </div>

    </div>
</template>

<style scoped>

</style>
